/**
 * Form group layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent, cloneElement } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Children from 'react-children-utilities';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import GridContainer from 'Common/Grid/GridContainer.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';
import { requiredValidation } from 'Utils';

export default class FormGroup extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        children: PropTypes.any,
        title: PropTypes.string,
        namePrefix: PropTypes.string,
        exclude: PropTypes.array,
        required: PropTypes.bool,
        onClear: PropTypes.any,
        customClass: PropTypes.string,
        customClassWrapper: PropTypes.string,
        customTitleClass: PropTypes.string,
        addtionalTitle: PropTypes.any,
        customTitleBlock: PropTypes.any,
    };

    static defaultProps = {
        required: false,
        namePrefix: null,
        exclude: [],
        children: null,
        customTitleBlock: null,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * Render children
     *
     * @returns {*}
     */
    renderChildren = () => {
        const { children, required, namePrefix, exclude } = this.props;

        let result = children;

        if (required || namePrefix || exclude.length) {
            result = Children.deepMap(result, child => {
                if (child && child.props) {
                    const props = child.props;

                    if (required) {
                        let required = false,
                            validate = [];
                        if (!('required' in props && props.required === false)) {
                            validate = [requiredValidation];
                            required = true;
                        }

                        if (Array.isArray(props.validate)) {
                            validate = [...validate, ...props.validate];
                        }

                        child = cloneElement(child, {
                            validate,
                            required,
                        });
                    }

                    if ('name' in props) {
                        const name = props.name;

                        if (exclude.indexOf(name) !== -1) {
                            child = null;
                        } else if (namePrefix) {
                            child = cloneElement(child, {
                                name: namePrefix + child.props.name,
                            });
                        }
                    }
                }

                return child;
            });
        }

        return result;
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { title, onClear, children, customClass, customClassWrapper, addtionalTitle, customTitleClass, customTitleBlock } = this.props;

        return (
            <div className={'form-grouper ' + customClassWrapper}>
                {title && (
                    <div className="mm-form-grouper-header">
                        <GridContainer>
                            <ItemGrid md={addtionalTitle ? 8 : 11} className={customTitleClass}>
                                <FormattedMessage id={title} />
                                {customTitleBlock}
                            </ItemGrid>
                            {addtionalTitle && <ItemGrid md={onClear ? 3 : 4}>
                                {addtionalTitle}
                            </ItemGrid>}
                            {onClear && <ItemGrid md={1}>
                                <IconButton aria-label="Remove" onClick={onClear}>
                                    <ClearIcon />
                                </IconButton>
                            </ItemGrid>}
                        </GridContainer>
                    </div>
                )}
                {children && <div className={'mm-form-grouper-content ' + customClass}>{this.renderChildren()}</div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FormGroup/FormGroup.jsx